import React from 'react';
import { styled } from '@linaria/react';
import { HighlightedTitle } from 'components/Home/HighlightedTitle';
import { Button } from '@daedalus/atlas/Button/Button';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Text } from '@daedalus/atlas/Text';
import { Team } from '@daedalus/core/src/analytics/types/Events';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { CitiesGroup } from './CitiesGroup';
import { useLocationTopDeals } from './hooks/useLocationTopDeals';
import { HotelsList } from './HotelsList';
const TopSection = /*#__PURE__*/styled('div')({
  name: "TopSection",
  class: "trzcvrv",
  propsAsIs: false
});
const _exp6 = /*#__PURE__*/() => Flex.Row;
const ButtonWrapper = /*#__PURE__*/styled(_exp6())({
  name: "ButtonWrapper",
  class: "b3jrxn8",
  propsAsIs: true
});
const _exp7 = /*#__PURE__*/() => Flex.Row;
const TitleWrapper = /*#__PURE__*/styled(_exp7())({
  name: "TitleWrapper",
  class: "tpzqx5j",
  propsAsIs: true
});
const PillsWrapper = /*#__PURE__*/styled('div')({
  name: "PillsWrapper",
  class: "p1kf7sqm",
  propsAsIs: false
});
const SeeAllText = /*#__PURE__*/styled('span')({
  name: "SeeAllText",
  class: "sdp7zvb",
  propsAsIs: false
});
export const TopDealsForTonight = () => {
  const {
    isMobile
  } = useDeviceLayout();
  const trackingPayload = {
    component: 'SuggestedProperties',
    team: Team.Retention
  };
  const {
    ref,
    onHotelClick,
    onSeeAllClick,
    handleChangeLocation,
    citiesList,
    selectedCity,
    checkIn,
    checkOut,
    isFetchingGeo,
    isCitiesGroupActive,
    togglePillsActivity
  } = useLocationTopDeals(trackingPayload);
  return <div ref={ref} className="chromatic-ignore">
      <TopSection>
        <TitleWrapper alignItems="center">
          <Text variant="titleXL">
            <HighlightedTitle source="TopDealsForTonight" />
          </Text>
        </TitleWrapper>
        <ButtonWrapper alignItems="flex-end">
          {!isMobile && <Button variant="secondary" onClick={onSeeAllClick}>
              <SeeAllText>
                <FormattedMessageWrapper id="hotelCard.seeAll" defaultMessage="See all" />
              </SeeAllText>
            </Button>}
        </ButtonWrapper>
        <PillsWrapper>
          <CitiesGroup items={citiesList} onPillClick={handleChangeLocation} isActive={!isFetchingGeo && isCitiesGroupActive} />
        </PillsWrapper>
      </TopSection>

      <Flex.Column gap="s400">
        {citiesList.map(city => <HotelsList key={`top-deals-${city.placeId}`} placeId={city?.placeId} selectedPlaceId={selectedCity?.placeId} checkIn={checkIn} checkOut={checkOut} rooms="2" trackingPayload={trackingPayload} isFetchingGeo={isFetchingGeo} onHotelClick={onHotelClick} hasSidePaddings={isMobile} numberOfResults={5} onRequestStart={togglePillsActivity(false)} onRequestComplete={togglePillsActivity(true)} />)}
      </Flex.Column>

      {isMobile && <ContentWrapper paddingX="s500" paddingTop="s500">
          <Button variant="secondary" fullWidth onClick={onSeeAllClick}>
            <SeeAllText>
              <FormattedMessageWrapper id="hotelCard.seeAll" defaultMessage="See all" />
            </SeeAllText>
          </Button>
        </ContentWrapper>}
    </div>;
};

require("./TopDealsForTonight.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./TopDealsForTonight.tsx");